import { useLocation } from 'react-router-dom';
import NicoAndByrneLogo from '../graphics/svg/nicoandbyrne.svg'
import { useEffect, useState } from 'react';

const SiteLogo = () => {
    const location = useLocation();
    const [active, setActive] = useState(false);

    const ue = useEffect(() => {
        setActive(!!(location.pathname !== "/" && location.pathname !== ""))
    }, [location])

    return(
        <>
            <img className={ active ? "menu_top_image active" : "menu_top_image" } alt='site logo' src={NicoAndByrneLogo} />
        </>
    )
}

export default SiteLogo;